import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, CircularProgress, Button, IconButton, Tooltip, } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import useTable from '../../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import CustomAlert from '../../CustomAlert';
import { Helmet } from 'react-helmet';
import { getAllUsersDocument } from '../../../Backend/firebase/supply-order';
import { parseDate } from '../../Models/CommonFunc';
import { useHistory } from 'react-router-dom';
import UserTypeDropdown from './UserTypeDropdown';
import jsPDF from "jspdf";
import "jspdf-autotable";
import Popup from '../../Popup';
import UpdateProfilePopup from '../UpdateProfilePopup';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'uid', label: 'Unique ID', disableSorting: false },
    { id: 'storeName', label: 'Store Name', disableSorting: false },
    { id: 'userRole', label: 'User Role', disableSorting: false },
    { id: 'phoneNumber', label: 'Phone Number', disableSorting: false },
    { id: 'storeAddress', label: 'Store Address', disableSorting: false },
    { id: 'gstNo', label: 'GST No', disableSorting: false },
    { id: 'drugLicense', label: 'Drug License', disableSorting: false },
    { id: 'active', label: 'Action', disableSorting: false },
]

function UsersHistory() {
    const classes = useStyles();
    const history = useHistory()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [selectedUserRole, setSelectedUserRole] = useState("");
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedUserProfile, setSelectedUserProfile] = useState(null);

    useEffect(async () => {
        var isLogin = localStorage.getItem(process.env.REACT_APP_EMPLOYER_ISLOGIN) || false;
        if (!isLogin || isLogin == "false") {
            history.push("/activity/Login");
        }
    }, [])

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items?.filter(x => x?.storeName?.toLowerCase()?.includes(target.value.toLowerCase()) ||
                        x?.storeAddress?.toLowerCase()?.includes(target.value.toLowerCase()) ||
                        x?.uid?.toLowerCase()?.includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getSupplyOrder = await getAllUsersDocument();
                setRecords(getSupplyOrder);
                setIsLoading(false);
            } catch (error) {
                console.log("Error Occur in Get Order", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const handleUserRoleFilters = (value) => {
        setFilterFn({
            fn: items => {
                if (value === "") {
                    return items
                } else {
                    return items?.filter(x => x?.userRole?.toLowerCase()?.includes(value.toLowerCase()));
                }
            }
        });
    }

    const convertToSlug = (input) => input?.toLowerCase()?.replace(/[^a-z0-9\s]/g, '')?.replace(/\s+/g, '_');
    
    // Function to download table data as a PDF
    const downloadPDF = () => {
        const doc = new jsPDF();
        const tableColumnHeaders = [
            "Unique ID",
            "Store Name",
            "User Role",
            "Phone Number",
            "Store Address",
            "GST No",
            "Drug License",
            "Created Date",
        ];

        // Map the data rows
        const tableRows = recordsAfterPagingAndSorting().map(item => [
            item?.uid ? item.uid : "NA",
            item?.storeName ? item.storeName : "NA",
            item?.userRole ? item.userRole : "NA",
            item?.phoneNumber ? item.phoneNumber : "NA",
            item?.storeAddress ? item.storeAddress : "NA",
            item?.gstNo ? item.gstNo : "NA",
            item?.drugLicense ? item.drugLicense : "NA",
            item?.createdAt ? typeof item?.createdAt == "string" ? item?.createdAt : parseDate(item?.createdAt) : "NA"
        ]);

        // Add the table to the PDF
        doc.autoTable({
            head: [tableColumnHeaders],
            body: tableRows,
        });

        // Save the PDF
        const fileName = selectedUserRole != "" ? `${convertToSlug(selectedUserRole)}.pdf` : "table_data.pdf"
        doc.save(fileName);
    };

    const updateUserProfile = (record) => {
        setSelectedUserProfile(record);
        setOpenPopup(true);
    };

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Order you have posted till now." />
                            <title>Users | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-5">
                                <h5>Users List</h5>
                            </div>
                            <div className="col-md-3"></div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Order..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            <div className="col-md-10">
                                <UserTypeDropdown
                                    handleFilters={handleUserRoleFilters} 
                                    selectedUserRole={selectedUserRole} 
                                    setSelectedUserRole={setSelectedUserRole} 
                                />
                            </div>
                            <div className="col-md-2 mt-4">
                                <Button
                                    onClick={downloadPDF}
                                    variant="contained"
                                    className="registerEmp__btnLogin jsmAdd"
                                >
                                    {'Export as PDF'}
                                </Button>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12 supply-order-table supply-partners-table">
                                <TblContainer>
                                    <TblHead />
                                    <TableBody>
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <TableRow key={item.id}>
                                                    <TableCell>{item?.uid ? `${item?.uid?.slice(0,8)}...` : "NA"}</TableCell>
                                                    <TableCell>{item?.storeName ? item.storeName : "NA"}</TableCell>
                                                    <TableCell>{item?.userRole ? item.userRole : "NA"}</TableCell>
                                                    <TableCell>{item?.phoneNumber ? item.phoneNumber : "NA"}</TableCell>
                                                    <TableCell>{item?.storeAddress ? item.storeAddress : "NA"}</TableCell>
                                                    <TableCell>{item?.gstNo ? item.gstNo : "NA"}</TableCell>
                                                    <TableCell>{item?.drugLicense ? item.drugLicense : "NA"}</TableCell>
                                                    {/* <TableCell>
                                                        {item?.createdAt ? typeof item?.createdAt == "string" ? item?.createdAt : parseDate(item?.createdAt) : "NA"}
                                                    </TableCell> */}
                                                    <TableCell>
                                                        <Tooltip title="Edit Profile" placement="top">
                                                            <IconButton 
                                                                color="primary"
                                                                onClick={() => updateUserProfile(item)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </TblContainer>
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No User Record Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Update Profile" popupSize="lg">
                <UpdateProfilePopup selectedUserProfile={selectedUserProfile} setOpenPopup={setOpenPopup} />
            </Popup>
        </>
    )
}

export default UsersHistory
